import { ChevronRight, Shield, Users, Building, Target, TrendingUp, DollarSign, Zap, CheckCircle } from 'lucide-react';
import { portfolioCompanies, companiesData } from '../../data/centralizedData';

// Icon mapping since we can't store React components in JSON
const iconMap = {
  Shield,
  Users,
  Building,
  Target,
  TrendingUp,
  DollarSign,
  Zap,
  CheckCircle
};

const Portfolio = ({ onSectionChange }) => (
  <div className="space-y-8">
    <div className="flex items-center justify-between">
      <h2 className="text-3xl font-bold text-gray-900">Portfolio Review</h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {portfolioCompanies.map((company) => (
        <div
          key={company.id}
          className="bg-white p-6 rounded-xl border shadow-sm hover:shadow-md transition-shadow cursor-pointer"
          onClick={() => onSectionChange(`portfolio/${company.id}`)}
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                {(() => {
                  const IconComponent = iconMap[company.icon];
                  return IconComponent ? <IconComponent className="w-5 h-5 text-gray-600" /> : null;
                })()}
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">{company.name}</h3>
                <p className="text-sm text-gray-600">{company.sector}</p>
              </div>
            </div>
            <ChevronRight className="w-4 h-4 text-gray-400" />
          </div>
          
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Status</span>
              <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                company.status === 'Active' ? 'bg-green-100 text-green-800' :
                company.status === 'Pilot' ? 'bg-blue-100 text-blue-800' :
                company.status === 'Onboarding' ? 'bg-yellow-100 text-yellow-800' :
                company.status === 'Not Active' ? 'bg-red-100 text-red-800' :
                'bg-gray-100 text-gray-800'
              }`}>
                {company.status}
              </span>
            </div>
            
            <div>
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm text-gray-600">Service CU Integration</span>
                <span className="text-sm font-medium">{company.integration}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-blue-500 h-2 rounded-full transition-all" 
                  style={{width: company.integration}}
                ></div>
              </div>
            </div>

            <div className="flex justify-between items-center pt-2">
              <span className="text-sm text-gray-600">YTD Revenue</span>
              <span className="text-sm font-bold text-green-600">{companiesData[company.id]?.revenue || '$0'}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Portfolio;